import { render, staticRenderFns } from "./editLectureDialog.vue?vue&type=template&id=3ffb2e55&scoped=true&"
import script from "./editLectureDialog.vue?vue&type=script&lang=js&"
export * from "./editLectureDialog.vue?vue&type=script&lang=js&"
import style0 from "./editLectureDialog.vue?vue&type=style&index=0&id=3ffb2e55&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffb2e55",
  null
  
)

export default component.exports